type LinkInfo = {
  category: number;
  device: number;
  articleId: number;
};

/** # 도움말 링크 정보
 * refer to https://docs.google.com/spreadsheets/d/1T4qm4R0MLIbDuiJj03FOSQyhspBX59kEEwBVArf6e1Y/edit#gid=1696660385
 * */
export const HELP_LINK_INFO = {
  // 홈 > MY BIZ
  HOME_MY_BIZ: {
    category: 985,
    device: 3620,
    articleId: 1073207106
  },
  // 홈 > 대시보드
  HOME_DASHBOARD: {
    category: 985,
    device: 3620,
    articleId: 1073207102
  },
  // 앱 정보 등록
  HOME_APP_CREATE: {
    category: 986,
    device: 3625,
    articleId: 1073207136
  },
  // 이용기관 등록
  PARTNER_REGISTER: {
    category: 986,
    device: 3623,
    articleId: 1073207127
  },
  // 이용기관 목록
  PARTNER_LIST: {
    category: 986,
    device: 3624,
    articleId: 1073207162
  },
  // 이용기관 상세
  PARTNER_DETAIL: {
    category: 986,
    device: 3624,
    articleId: 1073207162
  },
  // 기관 상세
  SVC_DETAIL: {
    category: 986,
    device: 3624,
    articleId: 1073207162
  },
  // 기관 추가
  SVC_CREATE: {
    category: 986,
    device: 3623,
    articleId: 1073207127
  },
  // 기관 정보 수정
  SVC_EDIT: {
    category: 986,
    device: 3624,
    articleId: 1073207162
  },
  // 기관 목록
  SVC_LIST: {
    category: 986,
    device: 3623,
    articleId: 1073207127
  },
  // 정보관리 > 멤버 관리
  INFO_MEMBER: {
    category: 987,
    device: 3626,
    articleId: 1073207139
  },
  // 정보관리 > 사업자 정보 관리
  INFO_BUSINESS: {
    category: 987,
    device: 3627,
    articleId: 1073207143
  },
  // 계약관리 > 딜러계약 조회
  CONTRACT_DEALER: {
    category: 988,
    device: 3629,
    articleId: 1073207154
  },
  // 계약관리 > 이용기관 계약 조회
  CONTRACT_PARTNER: {
    category: 988,
    device: 3629,
    articleId: 1073207156
  },
  // 계약관리 > 이용기관 계약 상세 조회
  CONTRACT_PARTNER_DETAIL: {
    category: 988,
    device: 3630,
    articleId: 1073207157
  },
  // 계약관리 > 이용기관 계약 추가
  CONTRACT_PARTNER_CREATE: {
    category: 988,
    device: 3628,
    articleId: 1073207146
  },
  // 계약관리 > 이용기관 계약 수정
  CONTRACT_PARTNER_EDIT: {
    category: 988,
    device: 3628,
    articleId: 1073207147
  },
  // 계약관리 > 상품계약 조회
  CONTRACT_PRODUCT: {
    category: 988,
    device: 3628,
    articleId: 1073207144
  },
  // 계약관리 > 상품계약 상세 조회
  CONTRACT_PRODUCT_DETAIL: {
    category: 988,
    device: 3630,
    articleId: 1073207157
  },
  // 통계 > 사용량 조회
  STATISTICS_USAGE: {
    category: 989,
    device: 3631,
    articleId: 1073207159
  },
  // 통계 > 통계 리포트
  STATISTICS_STATS: {
    category: 989,
    device: 4090,
    articleId: 1073211058
  },
  // 탈퇴
  LEAVE: {
    category: 989,
    device: 3621,
    articleId: 1073207122
  },
  // 정산관리 > 정산내역
  SETTLE_INVOICE: {
    category: 1059,
    device: 3870,
    articleId: 1073209736
  },
  // 정산관리 > 정산내역 > 상세 청구 정보
  SETTLE_INVOICE_DETAIL: {
    category: 1059,
    device: 3870,
    articleId: 1073209737
  },
  // 정산관리 > 세금계산서 발행 내역
  TAX_INVOICE: {
    category: 1059,
    device: 3871,
    articleId: 1073209741
  },
  // 정산관리 > 정산 기본 정보
  SETTLE_BASE_INFO: {
    category: 1059,
    device: 3872,
    articleId: 1073209743
  }
} satisfies Record<string, LinkInfo>;
